import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import React, { useRef, useState } from 'react';
import './PremiumEverydayPages.css';
import { Link } from 'react-router-dom';
import { memberExtrasRequest } from './subscriptionApi';

export default function MessageTranslation({ messageId }) {
  useSourceLanguage();
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState('fr');
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState({});
  const pending = useRef(false);
  const receipt = useRef(null);
  async function translate(event) {
    event.preventDefault();
    if (pending.current) return;
    pending.current = true; setState({ busy: true });
    if (!receipt.current || receipt.current.language !== language) receipt.current = { language, key: window.crypto.randomUUID() };
    try {
      const data = await memberExtrasRequest('translation/', { method: 'POST', body: { message_id: messageId, language, consent, request_key: receipt.current.key } });
      setState({ text: data.text, language: data.language });
    } catch (error) {
      setState({ error: error.message, locked: error.status === 403 });
      // A known rejection is final; an uncertain network retry keeps its receipt.
      if ([400, 503].includes(error.status)) receipt.current = null;
    } finally { pending.current = false; }
  }
  return <div className="message-translation">
    <button type="button" className="chat-message-translate" aria-expanded={open} onClick={() => setOpen(!open)}><LocalizedText source={"Traduire ce message · Premium"} /></button>
    {open && <form onSubmit={translate}>
      <label><LocalizedText source={"Langue de traduction "} /><select value={language} disabled={state.busy} onChange={e => { setLanguage(e.target.value); setState({}); }}>
        {Object.entries({ fr: 'Français', en: 'Anglais', es: 'Espagnol', de: 'Allemand', it: 'Italien', pt: 'Portugais' }).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
      </select></label>
      <label className="message-translation-consent"><input type="checkbox" checked={consent} disabled={state.busy} onChange={e => setConsent(e.target.checked)} required /><LocalizedText source={"J’autorise l’envoi de ce message au service IA pour le traduire."} /></label>
      <small><LocalizedText source={"Un crédit de rédaction Premium. Le résultat reste personnel et se retrouve dans votre historique du Studio."} /></small>
      <button type="submit" className="chat-message-translate" disabled={!consent || state.busy}>{state.busy ? <LocalizedText source={'Traduction en cours…'} /> : <LocalizedText source={'Afficher la traduction'} />}</button>
      {state.error && <p role="alert">{state.error} {state.locked && <Link to="/premium"><LocalizedText source={"Voir mon accès Premium"} /></Link>}</p>}
      {state.text && <div role="status"><small><LocalizedText source={"Traduction automatique · le message original est conservé"} /></small><p lang={state.language} style={{ whiteSpace: 'pre-wrap' }}>{state.text}</p></div>}
    </form>}
  </div>;
}
